//
//
//
//
//
//
//
//

import {BASIC,JPT_URL} from "@/config/constant"
export default {
    name:"preview",
    data(){
        return{
            id:'',
            url:""
        }
    },
    methods:{
        view(){
           var url=JPT_URL+BASIC+"/doc/preview?docId="+this.id;
           this.JX_download(url);
        },
        
        		// 下载最新版本	
		JX_download(url){
			plus.nativeUI.showWaiting( "下载中..." ); 
	                //创建下载管理对象
		        var SX_down= plus.downloader.createDownload(url,{}, function ( d, status ) {	
		        // 下载完成
		        if ( status == 200 ) { 
		    	    plus.nativeUI.closeWaiting();
		    	    //下载成功后的回调函数
		            // plus.nativeUI.toast( "下载成功，准备安装" + d.filename );
                    plus.runtime.openFile( d.filename, {}, function ( e ) {//调用第三方应用打开文件
                        plus.nativeUI.toast('打开失败');  
                    });

		        } else{
                      plus.nativeUI.closeWaiting();
                      plus.nativeUI.toast('下载失败');  
                }
		    });
		    SX_down.start(); 
		}
    }

}



// WEBPACK FOOTER //
// ./src/view/test/preview.vue